import { pdfMake, createHR, createParagraph, parseHtml } from "../pdfMake";

const getPDF = (data, isResidential, ExtraFooterContent) => {
    if (!data) {
        return null;
    }

    const docDefinition = {
        content: [],
        styles: {
            header: {
                fontSize: 15,
                bold: true,
                font: 'Graphik',
                margin: [10, 10],
            },
            main: {
                fontSize: 10,
                color: '#000',
                font: 'Graphik',
                margin: [15, 0, 10, 5],
            },
            footer: {
                fontSize: 7,
                margin: [35, 5, 10, 5],
                font: 'Graphik',
            },
            extrafooter: {
                fontSize: 14,
                margin: [35, 10, 10, 5],
                font: 'Graphik',
            },
            tableCell: {
                margin: [5, 5, 5, 5],
            },
        },
        header: [],
        footer: [],
        pageMargins: [30, 140, 10, 180],
        defaultStyle: {
            font: 'Graphik',
        },
    };

    docDefinition.header.push({
        image: 'KMCLogo.jpg',
        alignment: 'right',
        margin: [10, 20],
    });

    const todayDate = `Downloaded on ${new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    }).replace(/[^ -~]/g, '')}`;


    const lendingTitle = isResidential
        ? 'LENDING POLICY - \n RESIDENTIAL'
        : 'LENDING POLICY - \n BUY TO LET';

    docDefinition.content.push({
        text: lendingTitle,
        fontSize: 40,
        font: 'Druk',
        margin: [10, -120, 10, 20],
    });

    docDefinition.content.push({
        columns: [
            {
                text: 'FOR INTERMEDIARIES ONLY',
                fontSize: 16,
                font: 'Graphik',
                margin: [10, 10, 0, 10],
            },
            {
                text: todayDate,
                fontSize: 12,
                italics: true,
                alignment: 'right',
                margin: [10, 10],
            },
        ],
    });


    data.forEach(item => {
        docDefinition.content.push({ text: item.Title, style: 'header' });
        parseHtml(docDefinition.content, `<div>${item.Content}</div>`, ['style:main']);
        docDefinition.content.push(createParagraph());
    });

    docDefinition.footer.push(createHR());

    if (ExtraFooterContent) {
        parseHtml(docDefinition.footer, ExtraFooterContent, ["style:extrafooter"]);
    }
    docDefinition.footer.push(createHR());

    const footerContent = document.querySelector('footer .footerText');
    if (footerContent) {
        parseHtml(docDefinition.footer, footerContent.innerHTML, ["style:footer"]);
    }

    return pdfMake.createPdf(docDefinition);
}

export {
    getPDF
}